"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const verification_copy_1 = require("../constants/verification_copy");
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const doshx_controls_web_1 = require("doshx_controls_web");
const react_qr_code_1 = __importDefault(require("react-qr-code"));
const config_1 = require("../firebase/config");
const firestore_1 = require("firebase/firestore");
const create_qr_auth_session_1 = require("../api/calls/qr/create_qr_auth_session");
const ui_1 = require("../reducers/slices/ui");
const user_1 = require("../reducers/slices/user/user");
const authHelpers_1 = require("../firebase/authHelpers");
const routes_1 = require("../constants/routes");
const QrAuthModal = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const location = (0, react_router_dom_1.useLocation)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { showQrAuthModal } = (0, react_redux_1.useSelector)((state) => state.uiState);
    const { user, token, accessAuth } = (0, react_redux_1.useSelector)((state) => state.userState);
    const { selectedDocument, documentState } = (0, react_redux_1.useSelector)((state) => state.documentState);
    const [authMode, setAuthMode] = (0, react_1.useState)("qr");
    const [qrLoading, setQrLoading] = (0, react_1.useState)(false);
    const [qrError, setQrError] = (0, react_1.useState)(null);
    const [qrPayload, setQrPayload] = (0, react_1.useState)(null);
    const [qrExpiresAt, setQrExpiresAt] = (0, react_1.useState)(null);
    const [qrStatus, setQrStatus] = (0, react_1.useState)(null);
    const [cameraSupported, setCameraSupported] = (0, react_1.useState)(null);
    const [cameraPermissionDenied, setCameraPermissionDenied] = (0, react_1.useState)(false);
    const qrUnsubRef = (0, react_1.useRef)(null);
    const qrTimerRef = (0, react_1.useRef)(null);
    const clearQrFlow = (0, react_1.useCallback)((options) => {
        if (qrUnsubRef.current) {
            qrUnsubRef.current();
            qrUnsubRef.current = null;
        }
        if (qrTimerRef.current) {
            clearInterval(qrTimerRef.current);
            qrTimerRef.current = null;
        }
        setQrPayload(null);
        setQrExpiresAt(null);
        if (!(options === null || options === void 0 ? void 0 : options.keepStatus))
            setQrStatus(null);
        if (!(options === null || options === void 0 ? void 0 : options.keepError))
            setQrError(null);
    }, []);
    (0, react_1.useEffect)(() => {
        return () => clearQrFlow();
    }, [clearQrFlow]);
    // Detect camera availability/permission when modal opens
    (0, react_1.useEffect)(() => {
        if (!showQrAuthModal) {
            clearQrFlow();
            return;
        }
        let cancelled = false;
        const detectCamera = () => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b;
            if (!("mediaDevices" in navigator) || !((_a = navigator.mediaDevices) === null || _a === void 0 ? void 0 : _a.enumerateDevices)) {
                if (!cancelled)
                    setCameraSupported(false);
                return;
            }
            try {
                const devices = yield navigator.mediaDevices.enumerateDevices();
                const hasVideoInput = devices.some((d) => d.kind === "videoinput");
                if (!cancelled)
                    setCameraSupported(hasVideoInput);
                if ("permissions" in navigator && ((_b = navigator.permissions) === null || _b === void 0 ? void 0 : _b.query)) {
                    try {
                        const status = yield navigator.permissions.query({ name: "camera" });
                        if (!cancelled) {
                            setCameraPermissionDenied(status.state === "denied");
                        }
                        status.onchange = () => {
                            if (!cancelled) {
                                setCameraPermissionDenied(status.state === "denied");
                            }
                        };
                    }
                    catch (_) {
                        // ignore
                    }
                }
            }
            catch (_) {
                if (!cancelled)
                    setCameraSupported(false);
            }
        });
        detectCamera();
        return () => {
            cancelled = true;
        };
    }, [showQrAuthModal, clearQrFlow]);
    // Force QR tab when camera unavailable/denied
    (0, react_1.useEffect)(() => {
        if (cameraSupported === false || cameraPermissionDenied) {
            setAuthMode("qr");
        }
    }, [cameraSupported, cameraPermissionDenied]);
    const statusLabel = (0, react_1.useMemo)(() => {
        if (qrStatus)
            return qrStatus;
        if (qrExpiresAt) {
            return `Expires in ${Math.max(0, Math.floor((qrExpiresAt - Date.now()) / 1000))}s`;
        }
        return "Generate a code to begin";
    }, [qrExpiresAt, qrStatus]);
    const handleClose = () => {
        clearQrFlow();
        setAuthMode("qr");
        setQrStatus(null);
        setQrError(null);
        dispatch((0, ui_1.hideQrAuth)());
    };
    const ensureFirebaseSignedIn = () => __awaiter(void 0, void 0, void 0, function* () {
        if (config_1.auth.currentUser)
            return true;
        if ((user === null || user === void 0 ? void 0 : user.email) && token) {
            return (0, authHelpers_1.signInToFirebase)(user.email, "", token);
        }
        return false;
    });
    const handleGenerateQr = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e, _f;
        setQrLoading(true);
        setQrError(null);
        setQrStatus(null);
        clearQrFlow();
        try {
            // Ensure Firebase auth so we can obtain an ID token
            yield ensureFirebaseSignedIn();
            const firebaseToken = yield ((_a = config_1.auth.currentUser) === null || _a === void 0 ? void 0 : _a.getIdToken());
            if (!firebaseToken) {
                throw new Error("Missing Firebase auth token. Please sign in again.");
            }
            const response = yield (0, create_qr_auth_session_1.create_qr_auth_session)({
                authorization: firebaseToken,
                webApp: "sky_sign",
                expectedUid: (_c = (_b = config_1.auth.currentUser) === null || _b === void 0 ? void 0 : _b.uid) !== null && _c !== void 0 ? _c : null,
                facetecDbRef: (_d = user === null || user === void 0 ? void 0 : user.facetecDBRef) !== null && _d !== void 0 ? _d : null,
                metadata: {
                    userAgent: navigator.userAgent,
                    source: (_e = accessAuth === null || accessAuth === void 0 ? void 0 : accessAuth.view_type) !== null && _e !== void 0 ? _e : "web",
                },
            });
            const content = response === null || response === void 0 ? void 0 : response.content;
            if (!(content === null || content === void 0 ? void 0 : content.sessionId) || !(content === null || content === void 0 ? void 0 : content.token)) {
                throw new Error((response === null || response === void 0 ? void 0 : response.message) || "Failed to create QR auth session.");
            }
            const payloadParts = [`sid=${content.sessionId}`, `tok=${content.token}`];
            if (content.signature) {
                payloadParts.push(`sig=${content.signature}`);
            }
            const payload = `slqr://auth?${payloadParts.join("&")}`;
            setQrPayload(payload);
            setQrExpiresAt((_f = content.expiresAt) !== null && _f !== void 0 ? _f : Date.now() + 300000);
            setQrStatus("Waiting for mobile confirmation...");
            if (content.firestorePath) {
                const pathParts = content.firestorePath.split("/").filter(Boolean);
                if (pathParts.length >= 2) {
                    const docRef = (0, firestore_1.doc)(config_1.db, ...pathParts);
                    qrUnsubRef.current = (0, firestore_1.onSnapshot)(docRef, (snapshot) => {
                        const data = snapshot.data();
                        const status = data === null || data === void 0 ? void 0 : data.status;
                        if (!status)
                            return;
                        if (status === "verified") {
                            setQrStatus("Authentication confirmed.");
                            clearQrFlow();
                            dispatch((0, ui_1.faceTecAuthenticated)());
                            dispatch((0, user_1.setFaceTecAuthorized)(true));
                            dispatch((0, ui_1.resetAuthenticationInProgress)());
                            dispatch((0, ui_1.hideQrAuth)());
                        }
                        else if (status === "failed") {
                            setQrError("Authentication failed. Please retry.");
                        }
                        else if (status === "expired") {
                            setQrError("QR code expired. Please regenerate.");
                            clearQrFlow({ keepError: true });
                        }
                        else {
                            setQrStatus(`Status: ${status}`);
                        }
                    });
                }
            }
            qrTimerRef.current = setInterval(() => {
                setQrExpiresAt((prev) => {
                    if (!prev)
                        return prev;
                    if (prev <= Date.now()) {
                        setQrError("QR code expired. Please regenerate.");
                        clearQrFlow({ keepError: true });
                        return null;
                    }
                    return prev;
                });
            }, 1000);
        }
        catch (e) {
            setQrError((e === null || e === void 0 ? void 0 : e.message) || "Failed to start QR auth.");
        }
        finally {
            setQrLoading(false);
        }
    });
    if (!showQrAuthModal)
        return null;
    return (react_1.default.createElement(doshx_controls_web_1.ModalControl, { title: "Authenticate with mobile app or Facial Recognition", open: showQrAuthModal, onClose: handleClose },
        react_1.default.createElement("div", { className: "flex flex-col items-center w-full px-6 pb-6" },
            react_1.default.createElement("div", { className: "flex w-full max-w-md gap-2 p-1 bg-gray-100 rounded-lg mb-4" },
                react_1.default.createElement("button", { className: `flex-1 px-4 py-2.5 rounded-md text-sm font-medium transition-all duration-200 ${authMode === "qr"
                        ? "bg-primary text-white shadow-sm"
                        : "bg-transparent text-gray-600 hover:text-gray-800 hover:bg-gray-50"}`, onClick: () => setAuthMode("qr") }, "Mobile App (QR)"),
                react_1.default.createElement("button", { className: `flex-1 px-4 py-2.5 rounded-md text-sm font-medium transition-all duration-200 ${authMode === "facetec"
                        ? "bg-primary text-white shadow-sm"
                        : "bg-transparent text-gray-600 hover:text-gray-800 hover:bg-gray-50"}`, onClick: () => setAuthMode("facetec") }, "Facial Recognition")),
            (cameraSupported === false || cameraPermissionDenied) && (react_1.default.createElement("div", { className: "w-full max-w-md mb-4 px-4 py-3 bg-amber-50 border border-amber-200 rounded-lg" },
                react_1.default.createElement("p", { className: "text-sm text-amber-700 text-center" }, cameraSupported === false
                    ? "No camera detected. Please use the mobile app QR option."
                    : "Camera permission denied. Enable camera access or use the mobile app QR option."))),
            authMode === "facetec" ? (react_1.default.createElement("div", { className: "flex flex-col items-center w-full max-w-md py-8" },
                react_1.default.createElement("div", { className: "w-12 h-12 mb-4 border-4 border-gray-200 rounded-full border-t-primary animate-spin" }),
                react_1.default.createElement("p", { className: "text-gray-600 text-center mb-6" }, "Launch Facial Recognition on this device or switch to QR."),
                react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: verification_copy_1.FACIAL_RECOGNITION_START, backgroundColor: "bg-primary", textColor: "text-white", onClick: () => {
                        handleClose();
                        const searchParams = new URLSearchParams();
                        searchParams.set("method", "facetec");
                        if (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument._id) {
                            searchParams.set("return_to", "document");
                            searchParams.set("document_id", selectedDocument._id);
                            searchParams.set("type", documentState !== null && documentState !== void 0 ? documentState : "");
                        }
                        navigate(`${routes_1.CONSOLE_ROUTE}${routes_1.FACETEC_ROUTE}?${searchParams.toString()}`, { state: location.state });
                    } }))) : (react_1.default.createElement("div", { className: "flex flex-col items-center w-full max-w-md" },
                react_1.default.createElement("h3", { className: "text-lg font-semibold text-gray-800 mb-2 text-center" }, "Authenticate with your mobile app"),
                react_1.default.createElement("p", { className: "text-sm text-gray-500 mb-6 text-center max-w-sm" }, "Scan this QR code with the Sky Lifestyle mobile app to complete authentication."),
                react_1.default.createElement("div", { className: "flex flex-col items-center w-full" },
                    qrPayload ? (react_1.default.createElement("div", { className: "p-5 bg-white border-2 border-gray-100 rounded-xl shadow-sm" },
                        react_1.default.createElement(react_qr_code_1.default, { value: qrPayload, size: 180 }))) : (react_1.default.createElement("div", { className: "w-[220px] h-[220px] flex items-center justify-center border-2 border-dashed border-gray-200 rounded-xl bg-gray-50" },
                        react_1.default.createElement("span", { className: "text-sm text-gray-400 text-center px-4" }, "QR code will appear here"))),
                    react_1.default.createElement("p", { className: "mt-4 text-sm text-gray-500 text-center" }, statusLabel),
                    qrError && (react_1.default.createElement("p", { className: "mt-2 text-sm text-red-600 text-center" }, qrError)),
                    react_1.default.createElement("div", { className: "flex flex-col sm:flex-row items-center justify-center gap-3 mt-6 w-full" },
                        react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: qrLoading ? "Generating..." : "Generate QR Code", backgroundColor: "bg-primary", textColor: "text-white", onClick: handleGenerateQr, enabled: !qrLoading }),
                        qrPayload && (react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Reset", onClick: () => clearQrFlow(), backgroundColor: "bg-white", textColor: "text-gray-600", borderColor: "border-gray-300" })))))))));
};
exports.default = QrAuthModal;
